import * as types from './mutation-types'
import { convertIntToBoolean } from '@/helpers'

let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_CONTACT] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    convertIntToBoolean(payload, ['status'])
    state.contact = payload
  },
  [types.SET_CONTACTS] (state, payload) {
    state.contacts = []
    if (payload.data.length > 0) {
      for (let archive of payload.data) {
        convertIntToBoolean(archive, ['status'])
      }
      state.contacts = payload.data
    }
    state.pagination = payload.meta.pagination
  }
}
